/**
 * utils/preset-select-fill.js — пресеты из data-prompt-presets (JSON), подстановка в поле, селект в .js-preset-fill-block.
 * Публичный API: window.presetSelectFill и методы на нём.
 */
'use strict';

(function () {
    var PRESET_JSON_ATTR = 'data-prompt-presets';
    var PRESET_JSON_ATTR_ALT = 'data-presets';

    function decodeHtmlEntities(str) {
        if (!str || typeof str !== 'string') {
            return str;
        }
        if (typeof document === 'undefined' || !document.createElement) {
            return str;
        }
        let el = document.createElement('textarea');
        el.innerHTML = str;
        return el.value;
    }

    function tryParsePresetsJson(raw) {
        if (raw == null || typeof raw !== 'string') {
            return null;
        }
        raw = String(raw).replace(/^\uFEFF/, '').trim();
        if (!raw) {
            return null;
        }
        let candidates = [raw, decodeHtmlEntities(raw)];
        for (let i = 0; i < candidates.length; i++) {
            try {
                let p = JSON.parse(candidates[i]);
                if (Array.isArray(p)) {
                    return p;
                }
            } catch (err) {
                /* next */
            }
        }
        return null;
    }

    function rowValue(row) {
        if (row && row.value !== undefined && row.value !== null) {
            return String(row.value);
        }
        if (row && row.text !== undefined && row.text !== null) {
            return String(row.text);
        }
        return '';
    }

    function rowLabel(row) {
        if (!row || typeof row !== 'object') {
            return '';
        }
        if (row.label !== undefined && row.label !== null && String(row.label).trim() !== '') {
            return String(row.label);
        }
        if (row.text !== undefined && row.text !== null && String(row.text).trim() !== '') {
            return String(row.text);
        }
        let v = rowValue(row);
        return v.length > 80 ? v.slice(0, 77) + '…' : v;
    }

    function parsePresetsFromField(field) {
        if (!field || !field.length) {
            return [];
        }
        let dom = field[0];
        let parsed = null;
        let jqParsed = field.data('promptPresets');
        if (Array.isArray(jqParsed)) {
            parsed = jqParsed;
        }
        if (!parsed) {
            let raw = '';
            if (dom && dom.getAttribute) {
                raw = dom.getAttribute(PRESET_JSON_ATTR) || dom.getAttribute(PRESET_JSON_ATTR_ALT) || '';
            }
            if (!raw && dom && dom.dataset && dom.dataset.promptPresets !== undefined) {
                raw = String(dom.dataset.promptPresets);
            }
            if (!raw) {
                raw = field.attr(PRESET_JSON_ATTR) || field.attr(PRESET_JSON_ATTR_ALT) || '';
            }
            raw = String(raw || '').trim();
            parsed = tryParsePresetsJson(raw);
        }
        if (!parsed || !Array.isArray(parsed)) {
            return [];
        }
        let out = [];
        parsed.forEach(function (row) {
            if (!row || typeof row !== 'object') {
                return;
            }
            let value = rowValue(row);
            if (value === '') {
                return;
            }
            out.push({ label: rowLabel(row) || value, value: value });
        });
        return out;
    }

    function parsePresetsFromSelector(selector) {
        if (!selector) {
            return [];
        }
        return parsePresetsFromField(jQuery(selector));
    }

    function applyValueToField(field, value) {
        if (!field || !field.length) {
            return;
        }
        let ced = field.attr('contenteditable');
        if (ced !== undefined && String(ced).toLowerCase() === 'true') {
            field.text(value);
            field.trigger('input');
            return;
        }
        if (field.is('textarea') || field.is('select')) {
            field.val(value).trigger('input').trigger('change');
            return;
        }
        if (field.is('input')) {
            let type = String(field.attr('type') || 'text').toLowerCase();
            if (
                type === 'checkbox' ||
                type === 'radio' ||
                type === 'file' ||
                type === 'button' ||
                type === 'submit' ||
                type === 'reset' ||
                type === 'image'
            ) {
                return;
            }
            field.val(value).trigger('input').trigger('change');
        }
    }

    function fillPresetSelectOptions(selectEl, items) {
        let placeholder = selectEl.find('option:first').clone();
        selectEl.empty().append(placeholder);
        items.forEach(function (item) {
            let v = item.value != null ? String(item.value) : rowValue(item);
            selectEl.append(jQuery('<option></option>').attr('value', v).text(item.label || v));
        });
    }

    function initPresetSelectFill(root) {
        let rootWrap = root ? jQuery(root) : jQuery(document);
        let blockSel = '.js-preset-fill-block, .js-standard-prompt-block';
        rootWrap.find(blockSel).addBack(blockSel).each(function () {
            let block = jQuery(this);
            let targetSelector = String(
                block.attr('data-preset-target') || block.attr('data-prompt-target') || ''
            ).trim();
            let selectEl = block.find('.js-preset-fill-select, .js-standard-prompt-select');
            let targetField = targetSelector ? jQuery(targetSelector) : jQuery();
            let items = parsePresetsFromField(targetField);
            if (!selectEl.length || !targetField.length || !items.length) {
                return;
            }
            fillPresetSelectOptions(selectEl, items);
            selectEl.off('change.presetFill').on('change.presetFill', function () {
                let raw = jQuery(this).val();
                if (raw !== null && raw !== '') {
                    applyValueToField(targetField, raw);
                }
            });
        });
    }

    /**
     * Инициализация селектов пресетов на странице (без аргумента — весь document).
     * @param {string|Element|jQuery} [root]
     */
    window.presetSelectFill = function (root) {
        initPresetSelectFill(root);
    };

    window.presetSelectFill.parsePresetsFromField = parsePresetsFromField;
    window.presetSelectFill.parsePresetsFromSelector = parsePresetsFromSelector;
    window.presetSelectFill.applyValueToField = applyValueToField;
    window.presetSelectFill.initPresetSelectFill = initPresetSelectFill;
})();

jQuery(document).ready(function () {
    window.presetSelectFill();
});
